import { useEffect, useState } from "react";
import { useApplicationModals } from "app/common/hooks";
import * as Yup from "yup";
import { useCollector, useUpdateForm } from "app/integration/common/hooks";
import api from "app/integration/api";
import { useFetcher } from "app/integration/common/hooks";
import { ModalMolecule } from "app/components/molecules/modal";
import { Formik, FieldArray, getIn } from "formik";
import { InputMolecule } from "app/components/molecules/form";
import { InputLabel } from "app/components/atoms/form";
import { Button, DottedOutlineButton } from "app/components/atoms/button";
import { ClosableCard } from "app/components/atoms/card";
import { SelectMolecule } from "app/components/molecules/select";
import AppModals from ".";

function UpdateProductVariantModal({ onSuccess = () => {} }) {
  let isError = false;
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const { openModal, setPayloads } = useApplicationModals();
  const payload = getPayloads("productVariant.update");

  const [productName, setProductName] = useState("");

  const handleClose = () => closeModal("productVariant.update");
  const handleSuccess = () => {
    closeModal("productVariant.update");
    onSuccess();
  };

  const { initialValues, setInitialValues, validationSchema, onSubmit } =
    useUpdateForm({
      initialValues: {
        id: null,
        size_variant_id: null,
        color_variant_id: null,
        qty: 0,
      },
      validationSchema: Yup.object().shape({
        size_variant_id: Yup.number().required("Size harus diisi"),
        color_variant_id: Yup.number().required("Color harus diisi"),
        qty: Yup.number(),
      }),
      onSubmit: async (values) => {
        try {
          const response = await api.productVariant.update(
            values.id,
            values.size_variant_id,
            values.color_variant_id,
            values.qty
          );

          if (response && response.status == "success") {
            isError = false;
          }
        } catch (error) {
          setPayloads("errorMessage.view", {
            title: "Update Product Variant",
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : "Server Error",
          });
          isError = true;
          openModal("errorMessage.view");
        }
      },
      onSuccess: () => !isError && handleSuccess(),
    });

  const [productVariant, setVariant, loader, fetch] = useFetcher({
    modelName: "productVariant",
    payload,
  });

  const [sizes] = useCollector({
    modelName: "sizeVariant",
  });
  const [colors] = useCollector({
    modelName: "colorVariant",
  });

  useEffect(() => {
    setProductName(productVariant?.product_detail?.name);
    setInitialValues({
      id: productVariant.id,
      size_variant_id: productVariant.size_variant_id,
      color_variant_id: productVariant.color_variant_id,
      qty: productVariant.qty,
    });
  }, [productVariant]);

  return (
    <ModalMolecule
      show={showStates["productVariant.update"]}
      title={`Ubah Variant: ${productName}`}
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form className="space-y-2" onSubmit={handleSubmit}>
            <SelectMolecule testId="modal-update-product-variant-size-variant-id-select"
              label="Size"
              name="size_variant_id"
              options={sizes?.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.size_variant_id}
              errorMessage={
                errors.size_variant_id &&
                touched.size_variant_id &&
                errors.size_variant_id
              }
            />
            <SelectMolecule testId="modal-update-product-variant-color-variant-id-select"
              label="Color"
              name="color_variant_id"
              options={colors?.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.color_variant_id}
              errorMessage={
                errors.color_variant_id &&
                touched.color_variant_id &&
                errors.color_variant_id
              }
            />
            <InputMolecule testId="modal-update-product-variant-qty-input"
              label="Qty"
              type="text"
              name="qty"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.qty}
              errorMessage={errors.qty && touched.qty && errors.qty}
            />
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-update-product-variant-submit-button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default UpdateProductVariantModal;
